import React, { useRef, useMemo, useState, useEffect, useCallback } from 'react';
import { Menu } from 'antd';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import PageLoading from '../PageLoading';
import { generateNavMenuData } from 'src/utils/tree';
import { getSelectedKeys, urlToList } from './utils';
import { localeSelector } from 'src/selector/app';
import styles from './index.less';

const BaseMenu = (props) => {
  const ref = useRef();
  const router = useRouter();
  const locale = useSelector(localeSelector);
  const [selectedKeys, setSelectedKeys] = useState(() => []);
  const [openKeys, setOpenKeys] = useState([]);
  const { menuData, loadingMenu } = props;

  const menuItems = useMemo(() => {
    return generateNavMenuData({ navMenu: [], rawMenuData: menuData, locale });
  }, [menuData, locale]);

  useEffect(() => {
    let { pathname } = router;
    if (pathname === '/internal') pathname = '/internal/monthly-statement';
    const matchedUrl = urlToList(pathname);
    const selectedKeys = getSelectedKeys(menuData, matchedUrl);
    const { length } = selectedKeys;
    if (!length) return;
    setOpenKeys(length > 1 ? [selectedKeys[0]] : []);
    setSelectedKeys([selectedKeys[length - 1]]);
  }, [router.pathname, menuData]);

  const handleOpenChange = useCallback(
    (openKeys) => {
      const { length } = openKeys;
      setOpenKeys(length > 1 ? [openKeys[length - 1]] : openKeys);
    },
    [menuData]
  );

  return (
    <div className={styles.menuWrapper}>
      {loadingMenu ? (
        <PageLoading absoluteCenter />
      ) : (
        <Menu
          motion={{}}
          multiple={false}
          mode="inline"
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
          selectedKeys={selectedKeys}
          getPopupContainer={() => typeof document !== 'undefined' && document.body}
          items={menuItems}
        />
      )}
      <div ref={ref} />
    </div>
  );
};

export default BaseMenu;
